import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { DefaultChartDTO } from "api";
import { VarianceDropdown, DateRangeDropdown, YearOverYearDropdown, SingleYearByScopeDropdown } from "../../dropdowns";

export const SubTab = ({
  searchFilters,
  setSearchFilters,
  children,
  currentMainTab,
  subTypeChart,
  fiscalYears
}: {
  searchFilters: DefaultChartDTO;
  setSearchFilters: (param: DefaultChartDTO) => void;
  children?: React.ReactNode;
  currentMainTab: string;
  subTypeChart: string;
  fiscalYears: string[];
}) => {

  useEffect(() => {
    const updateSearch = (id: number) => {
      setSearchFilters({
        countryRegions: null,
        countries: null,
        siteIds: null,
        facilityTypes: null,
        businessUnits: null,
        scopes: null,
        utilityTypeIds: [id],
        accountNumbers: null,
        meterNumbers: null,
      });
    }
    if (subTypeChart === "electricity") {
      updateSearch(1)
    }

    if (subTypeChart === "natural gas") {
      updateSearch(2)
    }

    if (subTypeChart === "water") {
      updateSearch(5)
    }

    if (subTypeChart === "sewer") {
      updateSearch(8)
    }
  }, []); // eslint-disable-line

  return (
    <Box>
      {children}
      <Box sx={{ mt: 3, width: "calc(100vw - 145px)", display: "flex", flexDirection: "column", gap: 2 }}>
        <VarianceDropdown searchFilters={searchFilters} subTypeChart={subTypeChart} currentMainTab={currentMainTab} />
        <DateRangeDropdown searchFilters={searchFilters} subTypeChart={subTypeChart} currentMainTab={currentMainTab} />
        <YearOverYearDropdown searchFilters={searchFilters} subTypeChart={subTypeChart} currentMainTab={currentMainTab} />
        <SingleYearByScopeDropdown fiscalYears={fiscalYears} searchFilters={searchFilters} subTypeChart={subTypeChart} currentMainTab={currentMainTab} />
      </Box>
    </Box>
  )
}
